import { csx } from '@vtex/admin-ui'

export const styles = {
  container: csx({
    background: '$secondary',
    border: '$neutral',
    padding: '$space-4 $space-5',
    borderRadius: 4,
    zIndex: 2,
  }),
}
